import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Roster from './pages/Roster';
import Progress from './pages/Progress';
import Recruitment from './pages/Recruitment';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Register from './pages/Register';
import Login from './pages/Login';
import AdminApplications from './pages/AdminApplications';
import UserManagement from './pages/UserManagement';
import RosterOptimizer from './pages/RosterOptimizer';
import HousingPlotAdmin from './pages/HousingPlotAdmin';
// import HousingPlotPreferences from './pages/HousingPlotPreferences'; // Hidden - submissions closed
import HousingMap from './pages/HousingMap';
import MythicPlus from './pages/MythicPlus';
import RaidPolicies from './pages/RaidPolicies';
import Account from './pages/Account';
import Merch from './pages/Merch';
import Professions from './pages/Professions';
import ProfessionGuide from './pages/ProfessionGuide';
import MidnightSurvey from './pages/MidnightSurvey';
import MidnightSurveyAdmin from './pages/MidnightSurveyAdmin';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EditModeProvider } from './AuthContext';
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { app } from "./firebase";
// Expose Firestore for debugging
// @ts-ignore
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.db = getFirestore(app);
  // @ts-ignore
  window.addDoc = addDoc;
  // @ts-ignore
  window.collection = collection;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <EditModeProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/roster" element={<Roster />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/progress" element={<Progress />} />
              <Route path="/mythicplus" element={<MythicPlus />} />
              <Route path="/raid-rules" element={<RaidPolicies />} />
              <Route path="/merch" element={<Merch />} />
              <Route path="/recruitment" element={<Recruitment />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/account" element={<Account />} />
              {/* <Route path="/housing-preferences" element={<HousingPlotPreferences />} /> */}
              <Route path="/admin/applications" element={<AdminApplications />} />
              <Route path="/admin/users" element={<UserManagement />} />
              <Route path="/admin/roster-optimizer" element={<RosterOptimizer />} />
              <Route path="/admin/housing-plots" element={<HousingPlotAdmin />} />
              <Route path="/housing-map" element={<HousingMap />} />
              <Route path="/professions" element={<Professions />} />
              <Route path="/professions/:professionId" element={<ProfessionGuide />} />
              <Route path="/midnight-survey" element={<MidnightSurvey />} />
              <Route path="/admin/midnight-survey" element={<MidnightSurveyAdmin />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </EditModeProvider>
  );
}

export default App;
